// extracted by mini-css-extract-plugin
export default {"main":"About_main__y2PnZ","wrapper":"About_wrapper__1nIIg","content":"About_content__pGhsx","title":"About_title__1nWB8"};